module.exports = __webpack_public_path__ + "img/logo-footer.69605647.png";